import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import moment from 'moment'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            totalRow : null
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file_sk') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }

        return res;
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.detail?.punishment_discipline_uuid,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            detail: response,
                            documentSp: response.document_sp,
                            documentBap: response.document_bap,
                            documentLhp: response.document_lhp,
                            documentSk: response.document_sk
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid'), withdoc:1 })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayathukuman" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Hukuman Disiplin</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle> */}
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Pegawai Terkena Hukuman
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_nip !== "" ? this.state.detail.punishment_discipline_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_name !== "" ? this.state.detail.punishment_discipline_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_pangkat_golongan !== "" ? this.state.detail.employee_pangkat_golongan : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_position !== "" ? this.state.detail.punishment_discipline_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_employee_work_unit !== "" ? this.state.detail.punishment_discipline_employee_work_unit : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                # Atasan langsung
                                            </label>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_nip !== "" ? this.state.detail.punishment_discipline_head_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_name !== "" ? this.state.detail.punishment_discipline_head_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pangkat
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.head_pangkat_golongan !== "" ? this.state.detail.head_pangkat_golongan : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.punishment_discipline_head_employee_position !== "" ? this.state.detail.punishment_discipline_head_employee_position : '-'}</>
                                                    : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Rekomendasi Hukuman
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_punishment_name !== "" ? this.state.detail.punishment_discipline_punishment_name : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Keputusan Hukuman Berdasarkan Hasil Pemeriksaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_punishment_name !== "" ? this.state.detail.punishment_discipline_result_punishment_name : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Keterangan Hasil Pemeriksaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_description !== "" ? this.state.detail.punishment_discipline_result_description : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Hasil Akhir Keputusan Hukuman 
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_final_punishment_name !== "" ? this.state.detail.punishment_discipline_result_final_punishment_name : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Keterangan Hasil Akhir Keputusan Hukuman 
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_result_final_description !== "" ? this.state.detail.punishment_discipline_result_final_description : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor SK Hukuman
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_sk_number !== "" ? this.state.detail.punishment_discipline_sk_number : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tanggal SK Hukuman
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_sk_date !== "" ? this.dateParse(this.state.detail.punishment_discipline_sk_date) : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    TMT SK Hukuman
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>{this.state.detail.punishment_discipline_sk_tmt_date !== "" ? this.dateParse(this.state.detail.punishment_discipline_sk_tmt_date) : '-'}</>
                                                        : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                        <hr />
                                            
                                            {
                                                this.state.detail?.punishment_discipline_is_manual !== 1 && (
                                                    <>
                                                        <Row className="mb-3">
                                                            <Label className="col-md-3 col-form-label">File Surat Pemanggilan</Label>
                                                            <Col md="6">
                                                                {
                                                                    this.state.documentSp ?
                                                                        <>
                                                                            {this.state.documentSp !== null ?  
                                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.documentSp?.documents_path}>
                                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                                </a>
                                                                            : '-'}
                                                                        </>
                                                                    :
                                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                                }
                                                            </Col>
                                                        </Row>

                                                        <Row className="mb-3">
                                                            <Label className="col-md-3 col-form-label">File Berita Acara Pemeriksaan</Label>
                                                            <Col md="6">
                                                                {
                                                                    this.state.documentBap ?
                                                                        <>
                                                                            {this.state.documentBap !== null ?  
                                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.documentBap?.documents_path}>
                                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                                </a>
                                                                            : '-'}
                                                                        </>
                                                                    :
                                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                                }
                                                            </Col>
                                                        </Row>

                                                        <Row className="mb-3">
                                                            <Label className="col-md-3 col-form-label">File Laporan Hasil Pemeriksaan</Label>
                                                            <Col md="6">
                                                                {
                                                                    this.state.documentLhp ?
                                                                        <>
                                                                            {this.state.documentLhp !== null ?  
                                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.documentLhp?.documents_path}>
                                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                                </a>
                                                                            : '-'}
                                                                        </>
                                                                    :
                                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )
                                            }

                                            <Row className="mb-3">
                                                <Label className="col-md-3 col-form-label">File SK Hukuman</Label>
                                                <Col md="6">
                                                    {
                                                        this.state.documentSk ?
                                                            <>
                                                                {this.state.documentSk !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.documentSk?.documents_path}>
                                                                        Download <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : '-'}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayathukuman">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayathukuman'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);